import { render, staticRenderFns } from "./DetailVarExpensesModal.vue?vue&type=template&id=f4a9c150"
import script from "./DetailVarExpensesModal.vue?vue&type=script&lang=js"
export * from "./DetailVarExpensesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports